import {
  PenLine,
  FileCheck2,
  FlaskConical,
  Pill,
  Presentation,
  GraduationCap,
} from "lucide-react";

export const services = [
  {
    id: "medical-scientific-writing",
    index: "01",
    title: "Medical & Scientific Writing",
    icon: PenLine,
    blurb: "Publication-ready scientific content, written and structured by domain experts.",
    description:
      "Clear, rigorous, and journal-ready writing across therapeutic areas. From first-draft research articles to funded grant proposals, every document is built on verified evidence, precise methodology, and the conventions of your target audience.",
    subs: [
      "Research Articles",
      "Systematic Reviews",
      "Narrative Reviews",
      "Case Reports",
      "Grant Proposals",
      "Technical Documentation",
    ],
  },
  {
    id: "manuscript-editing-publication-support",
    index: "02",
    title: "Manuscript Editing & Publication Support",
    icon: FileCheck2,
    blurb: "From rough draft to accepted manuscript — we navigate the journal maze with you.",
    description:
      "Substantive editing that sharpens argument, structure, and language, paired with end-to-end publication strategy: the right journal, a compelling cover letter, and point-by-point reviewer responses that move your paper toward acceptance.",
    subs: [
      "Manuscript Editing",
      "Journal Selection",
      "Reviewer Responses",
      "Formatting & Submission",
      "Cover Letters",
      "Graphical Abstracts",
    ],
  },
  {
    id: "clinical-research-data-support",
    index: "03",
    title: "Clinical Research & Data Support",
    icon: FlaskConical,
    blurb: "Protocol to publication — methodologically sound clinical evidence.",
    description:
      "Support across the clinical evidence chain: protocol development, statistical planning, meta-analysis, and real-world evidence generation — executed with the rigour regulators and journals expect.",
    subs: [
      "Clinical Protocols",
      "Meta-Analysis",
      "Real-World Evidence (RWE)",
      "Biostatistics Support",
      "Safety Narratives",
      "Data Interpretation",
    ],
  },
  {
    id: "pharmaceutical-rnd-consulting",
    index: "04",
    title: "Pharmaceutical R&D Consulting",
    icon: Pill,
    blurb: "Scientific intelligence for discovery, development, and pipeline decisions.",
    description:
      "Embedded scientific consulting for pharma and biotech teams: mechanistic analysis, discovery support, and landscape intelligence that de-risks decisions from hit identification to development strategy.",
    subs: [
      "Drug Discovery Support",
      "SAR / MoA Analysis",
      "Preclinical Study Design",
      "Regulatory Documentation",
      "Competitive Intelligence",
      "Pipeline Landscaping",
    ],
  },
  {
    id: "medical-education-promotional-content",
    index: "05",
    title: "Medical Education & Promotional Content",
    icon: Presentation,
    blurb: "Scientifically accurate content that educates, engages, and complies.",
    description:
      "CME modules, congress presentations, and promotional materials that translate complex science into compelling narratives — always accurate, always compliant, always on-brand.",
    subs: [
      "Scientific Presentations",
      "Slide Decks",
      "CME Modules",
      "Promotional Content",
      "Training Compendiums",
      "Medical Infographics",
    ],
  },
  {
    id: "academic-institutional-support",
    index: "06",
    title: "Academic & Institutional Support",
    icon: GraduationCap,
    blurb: "Thesis to tenure — structured support for researchers and institutions.",
    description:
      "Mentorship-grade support for scholars and institutions: theses, synopses, dissertations, and publication strategy that meet institutional standards and accelerate academic careers.",
    subs: [
      "Thesis Editing",
      "Research Synopsis",
      "Dissertation Support",
      "Grant Writing",
      "Publication Strategy",
      "Conference Abstracts",
    ],
  },
];

export const serviceOptions = [...services.map((s) => s.title), "Other / Not Sure Yet"];
